import { render, staticRenderFns } from "./SeverityDistribution.vue?vue&type=template&id=7bca0564&scoped=true"
import script from "./SeverityDistribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeverityDistribution.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SeverityDistribution.vue?vue&type=style&index=0&id=7bca0564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bca0564",
  null
  
)

export default component.exports